export class Usuario {
  constructor(
    public nombre: string,
    public email: string,
    public clave: string,
    public img?: string,
    public rol?: string,
    public google?: number,
    public CantPag: number = 0,
    public id?: number
  ) {}
}
